import type { WritableSignal } from '@angular/core';
import type { InternalNotification } from '../../../../shared/notification/notification';
import {
	createErrorNotification,
	createSuccessNotification,
} from '../../../../shared/notification/notification.factory';

export interface DatabaseCsvExportOptions {
	exporting: WritableSignal<boolean>;
	fetchCsv: () => Promise<Blob>;
	filename: string;
	translate: (key: string) => string;
	notify: (notification: InternalNotification) => void;
}

export async function runDatabaseCsvExport(options: DatabaseCsvExportOptions): Promise<void> {
	const { exporting, fetchCsv, filename, translate, notify } = options;
	exporting.set(true);

	try {
		const blob = await fetchCsv();
		const url = window.URL.createObjectURL(blob);
		const a = document.createElement('a');
		a.href = url;
		a.download = filename;
		a.click();
		window.URL.revokeObjectURL(url);

		notify(createSuccessNotification(translate('base.notification_message.file_downloaded')));
	} catch {
		notify(createErrorNotification(translate('base.notification_message.file_download_error')));
	} finally {
		exporting.set(false);
	}
}
